/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService, Logger, LogService } from '@epg/angular-base-lib';
import { getActiveTenantFromSessionStorage } from '../app/shared/functions';
import { SearchModel } from '../models/search.model';

export const COMPANY_NAME_QUERY_PARAM = 'company_name';
// for blobservice
export const TENANT_QUERY_PARAM = 'tenant';

@Injectable({
  providedIn: 'root'
})
// TODO: implement an interface
export class ApiService {
  apiEndPoint: string;

  protected log: Logger;
  constructor(
    protected http: HttpClient,
    protected appConfig: AppConfigService,
    protected logService: LogService
  ) {
    this.log = this.logService.getLogger(this);
    try {
      this.apiEndPoint = this.appConfig.getParameter('ApiEndpoint') as string;
      if (!this.apiEndPoint.endsWith('/')) {
        this.apiEndPoint = this.apiEndPoint.concat('/');
      }
    } catch {
      this.log.debug('No API Endpoint defined!');
      this.apiEndPoint = '';
    }
  }

  //#region general
  getQueryParams(queryParams = new HttpParams()): HttpParams {
    const tenant = getActiveTenantFromSessionStorage();
    if (tenant && !queryParams.has(COMPANY_NAME_QUERY_PARAM)) {
      queryParams = queryParams.append(COMPANY_NAME_QUERY_PARAM, tenant);
    }
    return queryParams;
  }

  get(url: string, queryParams: HttpParams = new HttpParams()) {
    return this.http.get<any>(this.apiEndPoint + url, {
      params: this.getQueryParams(queryParams)
    });
  }

  post(url: string, body: any, queryParams: HttpParams = new HttpParams()) {
    return this.http.post<any>(this.apiEndPoint + url, body, {
      params: this.getQueryParams(queryParams)
    });
  }

  put(url: string, body: any, queryParams: HttpParams = new HttpParams()) {
    return this.http.put<any>(this.apiEndPoint + url, body, {
      params: this.getQueryParams(queryParams)
    });
  }

  // patch is only used for task static data update
  patch(url: string, body: any, queryParams: HttpParams = new HttpParams()) {
    return this.http.patch<any>(this.apiEndPoint + url, body, {
      params: this.getQueryParams(queryParams)
    });
  }

  delete(url: string, queryParams: HttpParams = new HttpParams()) {
    return this.http.delete<any>(this.apiEndPoint + url, {
      params: this.getQueryParams(queryParams)
    });
  }

  search(url: string, searchBody: SearchModel, queryParams: HttpParams = new HttpParams()) {
    this.log.debug(`ACTIVE_TENANT_VARIABLE: ${getActiveTenantFromSessionStorage()}`);
    return this.http.post<any[]>(this.apiEndPoint + url, searchBody, {
      observe: 'response',
      params: this.getQueryParams(queryParams)
    });
  }
  //#endregion

  getImageDatum(imageReference: string) {
    return this.http.get(this.apiEndPoint + 'imagedatum/' + imageReference, {
      responseType: 'text'
    });
  }
}

@Injectable({
  providedIn: 'root'
})
export class DesignerApiService extends ApiService {
  constructor(
    protected http: HttpClient,
    protected appConfig: AppConfigService,
    protected logService: LogService
  ) {
    super(http, appConfig, logService);
    this.log = this.logService.getLogger(this);
    try {
      this.apiEndPoint = this.appConfig.getParameter('DesignerApiEndpoint') as string;
      if (!this.apiEndPoint.endsWith('/')) {
        this.apiEndPoint = this.apiEndPoint.concat('/');
      }
    } catch {
      this.log.debug('No API Endpoint defined!');
      this.apiEndPoint = '';
    }
  }
}
